/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInterestPayouts} from '../api'

 export const useQueryGetInterestPayouts = createReactQueryHook('getInterestPayouts', getInterestPayouts)
